module.exports = __webpack_public_path__ + "static/media/shnonco_logo.ad7bb977.jpeg";